import { useSubscription } from "@apollo/client";
import { SUMMARY_CHANGE_SUBSCRIPTION } from "../../queries";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { Alert } from "@mui/material";

interface SummaryUpdateSubscriptionProps {
	CountSummaryID: number;
	JobID: number;
}

const SummaryUpdateSubscription = ({ CountSummaryID, JobID }: SummaryUpdateSubscriptionProps) => {
	let { id } = useParams();
	const { data, loading, error } = useSubscription(SUMMARY_CHANGE_SUBSCRIPTION, { variables: { DeviceID: Number(id), CountSummaryID, JobID } });

	useEffect(() => {
		console.log("SummaryUpdateSubscription  useEffect data loading error", data, loading, error);
	}, [data, loading, error]);

	return <>{error ? <Alert severity="warning">Job Info may not refresh if changed from another device.</Alert> : null}</>;
};

export default SummaryUpdateSubscription;
